import { Box } from "@mui/material";
import { useState } from "react";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "../BuildlingBlocks/UILabel";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";

export class StoryNode {
    id: string;
    path: string[] = [];
    name: string;
    private renderStory?: (logCallback: (logMessage: string) => void) => JSX.Element;

    constructor(renderStory: (logCallback: (logMessage: string) => void) => JSX.Element, ...path: string[]) {
        this.id = path.join("--");
        this.id = this.id.replace("/", "");
        this.id = this.id.replace(" ", "-");

        this.name = path.pop() ?? "";
        this.path = path;

        this.renderStory =
            renderStory ??
            (() => {
                return <>No node here</>;
            });
    }

    private _subNodes: StoryNode[] = [];

    get subNodes(): StoryNode[] {
        let retNodes = this._subNodes.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        return retNodes;
    }

    addSubNode(node: StoryNode) {
        this._subNodes.push(node);
    }

    render(): JSX.Element {
        return (
            <StoryRender
                id={this.id}
                key={this.id}
                renderStory={this.renderStory}
            />
        );
    }

    getSubNode(name: string): StoryNode | undefined {
        for (let n of this._subNodes) {
            if (n.name === name) return n;
        }

        return undefined;
    }
}

function StoryRender(props: { id: string; renderStory?: (logCallback: (logMessage: string) => void) => JSX.Element }) {
    let [logMessages, setLogMessages] = useState<string[]>([]);
    if (props.renderStory) {
        let story = props.renderStory((logMessage) => {
            let messages = [...logMessages];
            messages.push(logMessage);
            setLogMessages(messages);
        });
        if (story)
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    style={{ height: "100%" }}
                    key={props.id + "story"}
                >
                    <Box style={{ height: "100%" }}>{story}</Box>
                    {logMessages.length !== 0 && (
                        <Box
                            display={"flex"}
                            flexDirection={"column"}
                            border={"1px solid " + UIStyleConstants.GRAY_LIGHTER_COLOR}
                        >
                            <UILabel>Log Messages</UILabel>
                            <ul>
                                {logMessages.map((m) => {
                                    return <li key={DataUtilities.generateUniqueId()}>{m}</li>;
                                })}
                            </ul>
                        </Box>
                    )}
                </Box>
            );
    }

    return <>Select Sub Node</>;
}

export class StoryData {
    static rootNode = new StoryNode(() => {
        return <>root node</>;
    }, "/");

    static nodes: { [id: string]: StoryNode } = {};

    static addNodes(nodes: StoryNode[]) {
        for (let n of nodes) {
            this.addNode(n);
        }
    }

    static addNode(node: StoryNode) {
        if (!this.nodes[this.rootNode.id]) this.nodes[this.rootNode.id] = this.rootNode;

        this.nodes[node.id] = node;

        let currentNode = this.rootNode;

        let currentPath: string[] = [];

        currentPath.push(currentNode.name);

        for (let p of node.path) {
            currentPath.push(p);
            let sub = currentNode.getSubNode(p);
            if (sub) {
                currentNode = sub;
            } else {
                sub = new StoryNode(
                    () => {
                        return <>Select Node</>;
                    },
                    ...currentPath,
                );
                currentNode.addSubNode(sub);
                currentNode = sub;
            }
        }

        if (!currentNode.getSubNode(node.name)) currentNode.addSubNode(node);
    }

    static getStoryNode(id: string): StoryNode | undefined {
        return this.nodes[id];
    }
}
